<script>

    import { shipmentStore, modalStore } from '../stores'

    import ShipmentComponent from './component.shipment.svelte'
    import OrderPackageComponent from '../orders/component.package.svelte'
    import OrderLocationComponent from '../orders/component.location.svelte'

    import ChargesShipmentComponent from '../charges/component.charges.shipment.svelte'
    import ChargeCreateComponent from '../charges/component.create.svelte'

    import TrackingComponent from '../trackings/component.tracking.svelte'
    import TrackingStatusComponent from '../trackings/component.tracking.status.svelte'
    
    import TracingComponent from '../tracings/component.tracings.svelte'
    import TracingCreateComponent from '../tracings/component.create.svelte'

    import ShipmentTrackingUpdateComponent from '../shipments/component.shipment.tracking.update.svelte'

    import Modal from '../$components/modal.svelte'
    import Tabs from '../$components/tabs.svelte'

    $: show = $modalStore === 'shipment_modal'

    let tabSelected = 'information'

    const tabOptions = [
        {key: 'information', name: 'Informacion', icon: 'info-circle'},
        {key: 'charges', name: 'Cargos', icon: 'file-invoice-dollar'},
        {key: 'tracking', name: 'Tracking', icon: 'map-marker-alt'},
        {key: 'trackingUpdate', name: 'Actualizar Tracking', icon: 'map-marker-alt'},
        {key: 'tracing', name: 'Seguimiento', icon: 'comments'},
    ]

</script>

{#if $shipmentStore}
    <Modal title="{$shipmentStore.guide}" {show} >

        <Tabs bind:selected={tabSelected} options={tabOptions} />

        {#if tabSelected === 'information'}
            <ShipmentComponent />
            <OrderPackageComponent />
            <OrderLocationComponent subtitle="Origen" orderLocation={$shipmentStore.order.pickup} />
            <OrderLocationComponent subtitle="Destino" orderLocation={$shipmentStore.order.delivery} />
        {/if}

        {#if tabSelected === 'charges'}
            <ChargesShipmentComponent />
            <ChargeCreateComponent shipmentId={$shipmentStore._id} userId={$shipmentStore.userId} />
        {/if}

        {#if tabSelected === 'tracking'}
            <TrackingStatusComponent />
            <TrackingComponent />
        {/if}

        {#if tabSelected === 'trackingUpdate'}
            <ShipmentTrackingUpdateComponent />
        {/if}

        {#if tabSelected === 'tracing'}
            <TrackingStatusComponent />
            <TracingComponent />
            <TracingCreateComponent />
        {/if}

    </Modal>
{/if}